var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913",
    transform: "translate(-107 -577)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    transform: "translate(107 577)",
    fill: "#f6ecfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "folder-unknow-line",
    transform: "translate(119 589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M0,0H29.364V29.364H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M14.742,5.447H25.247A1.224,1.224,0,0,1,26.47,6.671V23.8a1.224,1.224,0,0,1-1.224,1.224H3.224A1.224,1.224,0,0,1,2,23.8V4.224A1.224,1.224,0,0,1,3.224,3h9.071Zm-10.295,0V22.576H24.023V7.894H13.729L11.282,5.447Zm8.565,13.459h2.447v2.447H13.012Zm-2.977-6.346a4.284,4.284,0,1,1,4.2,5.123H13.012V15.235h1.224a1.835,1.835,0,1,0-1.8-2.195l-2.4-.481Z",
    transform: "translate(0.447 0.671)",
    fill: "#5D5FEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupIcon);
export default __webpack_public_path__ + "static/media/popup-icon.45c5c02e42c8d5f8a40b6464932ec11f.svg";
export { ForwardRef as ReactComponent };